import {
    config,
} from './utils';

const login = async (formData) => {
    const request = await fetch(config.apiUrl + '/api/usuario/login', {
        method: 'POST',
        body: JSON.stringify(formData),
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        mode: 'cors',
    });
    const response = await request.json();
    if (request.status !== 200) {
        throw response;
    }
    return response;
};

const logout = async () => {
    const request = await fetch(config.apiUrl + '/api/usuario/logout', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        mode: 'cors',
    });
    const response = await request.json();
    if (request.status !== 200) {
        throw response;
    }
    return response;
};

const getLoginForm = async () => {
    return fetch(config.apiUrl + '/api/usuario/login', {
        credentials: 'include',
        mode: 'cors',
    }).then(response => response.json());
};

export {
    login,
    logout,
    getLoginForm,
};